import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

const ScrollToTop = () => {
  const [showIcon, setShowIcon] = useState(false);

  useEffect(() => {
    document.addEventListener("scroll", () => {
      setShowIcon(window.scrollY > 170);
    });
  }, []);

  const scrollToTop = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  };

  const renderGoTopIcon = () => {
    if (showIcon) {
      return (
        <div
          className={`go-top`}
          style={{ zIndex: "9999" }}
          id="linkScrollToTop"
          onClick={scrollToTop}
        >
          <FontAwesomeIcon icon={faArrowUp} />
        </div>
      );
    }
  };

  return <>{renderGoTopIcon()}</>;
};

export default ScrollToTop;
